const MOBILE_CLUB_YANDEX_GOALS = {
  appointmentNoticeShow: 'mobileClub__appointmentNoticeShow', // Предложение записаться(bottom sheet) при клике на номер телефона
  appointmentNoticeGoToApp: 'mobileClub__appointmentNoticeGoToApp', // Предложение записаться(bottom sheet), клик по кнопке 'записаться'
  appointmentNoticeCall: 'mobileClub__appointmentNoticeCall', // Предложение записаться(bottom sheet), клик по кнопке 'позвонить'
}

export default MOBILE_CLUB_YANDEX_GOALS
